import React from "react";
import SlateEditor from "../slateEditor/SlateEditor";
import { FaPen, FaRegTrashAlt } from "react-icons/fa";
import ModalStructure from "../ModalStructure";
import BlogForm from "./BlogForm";
import Notification from "../ui-elements/Notification";
import { deleteBlog, deleteBlogImage } from "../../services/blogs";
import { IS_LOCAL_ENV } from "../../App";

const BlogCard = ({ info, loadToParent, removeFromParent }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);

  const handleDelete = async (e, id) => {
    e.preventDefault();
    setUploading(true);
    const deleteFetch = async () => {
      try {
        //eliminar imagen anterior
        if (info?.image) await deleteBlogImage(info.image.id);

        const { data } = await deleteBlog(id);
        Notification({
          title: "Operación completada",
          text: `Se eliminó el blog con éxito`,
          type: "Success",
        });
        setUploading(false);
        removeFromParent(info.id);
      } catch (err) {
        setUploading(false);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };

    deleteFetch();
  };

  return (
    <div className="max-w-[800px] w-full flex flex-col rounded-xl border-[1px] bg-white border-accent-green p-6 shadow-md gap-y-4 font-poppins">
      <div className={`h-[200px] w-full relative`}>
        <img
          src={`${process.env.REACT_APP_SERVER}${info.image.url}`}
          alt="Cropped example"
          className="w-full h-full object-cover object-center rounded-[5px]"
        />
      </div>
      <div className="w-full flex flex-col gap-y-2 relative items-center">
        <h3 className="font-bold text-dark-green text-wrap text-xl w-[70%] text-center">
          {info.title}
        </h3>
        <div className="flex flex-row absolute top-[0px] right-[5px]">
          <button
            className="hover:bg-light-green text-dark-green rounded-full p-2 text-sm"
            onClick={() => setShowModal(true)}
          >
            <FaPen />
          </button>
          <button
            className="hover:bg-light-green text-dark-green rounded-full p-2 text-sm"
            onClick={() => setShowDeleteModal(true)}
          >
            <FaRegTrashAlt />
          </button>
        </div>
        <div className="flex flex-col gap-y-2 items-center w-full">
          <p className="text-dark-green text-sm w-full">
            <span className="font-bold">Descripción:</span> {info.description}
          </p>
          <span className="font-bold">Contenido:</span>
          <div className="bg-light-green p-4 max-h-[350px] overflow-y-auto w-full">
            <p className=" text-dark-green  text-sm ">
              <SlateEditor
                //la info de details se está trayendo en js en lugar de json
                //una opcion es pasarlo a json
                //la otra es configurar para recibirlo en slateeditor como js o json
                prevValue={info?.content ? JSON.stringify(info.content) : null}
                editable={false}
                //customMaxW={"max-w-[435px]"}
                //onChangeData={handleDetailsChange}
              />
            </p>
          </div>
        </div>
      </div>
      {/**Modals */}
      {showModal && (
        <ModalStructure handleCloseModal={() => setShowModal(false)}>
          <BlogForm
            prevData={info}
            handleClose={() => setShowModal(false)}
            loadToParent={loadToParent}
          />
        </ModalStructure>
      )}
      {showDeleteModal && (
        <ModalStructure
          handleCloseModal={() => setShowDeleteModal(false)}
          customMaxW={"max-w-[400px]"}
        >
          <div className="flex flex-col items-center justify-center gap-y-2 p-4">
            <h3 className="font-bold text-dark-green text-lg text-center">
              ¿Estás seguro de eliminar este blog?
            </h3>
            <button
              disabled={uploading}
              className={`${
                uploading
                  ? "bg-light-gray cursor-not-allowed"
                  : "hover:bg-red-300 bg-red-500"
              } text-white rounded-full py-2 px-4 text-base font-poppins`}
              onClick={(e) => (uploading ? null : handleDelete(e, info.id))}
            >
              Eliminar
            </button>
          </div>
        </ModalStructure>
      )}
    </div>
  );
};

export default BlogCard;
